if (typeof lazySizes === 'undefined') {
  /*! lazysizes - v4.1.8 */
  !(function (a, b) { const c = b(a, a.document); a.lazySizes = c, typeof module === 'object' && module.exports && (module.exports = c); }(window, (a, b) => {
    if (b.getElementsByClassName) {
      let c; let d; const e = b.documentElement; const f = a.Date; const g = a.HTMLPictureElement; const h = 'addEventListener'; const i = 'getAttribute'; const j = a[h]; const k = a.setTimeout; const l = a.requestAnimationFrame || k; const m = a.requestIdleCallback; const n = /^picture$/i; const o = ['load', 'error', 'lazyincluded', '_lazyloaded']; const p = {}; const q = Array.prototype.forEach; const r = function (a, b) { return p[b] || (p[b] = new RegExp(`(\\s|^)${b}(\\s|$)`)), p[b].test(a[i]('class') || '') && p[b]; }; const s = function (a, b) { r(a, b) || a.setAttribute('class', `${(a[i]('class') || '').trim()} ${b}`); }; const t = function (a, b) { let c; (c = r(a, b)) && a.setAttribute('class', (a[i]('class') || '').replace(c, ' ')); }; var u = function (a, b, c) { const d = c ? h : 'removeEventListener'; c && u(a, b), o.forEach((c) => { a[d](c, b); }); }; const v = function (a, d, e, f, g) { const h = b.createEvent('Event'); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h; }; const w = function (b, c) { let e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]('srcset') && b.setAttribute('srcset', c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src); }; const x = function (a, b) { return (getComputedStyle(a, null) || {})[b]; }; const y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c; }; const z = (function () {
        let a; let c; const d = []; const e = []; let f = d; const g = function () { const b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1; }; const
          h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))); }; return h._lsFlush = g, h;
      }()); const A = function (a, b) {
        return b ? function () { z(a); } : function () {
          const b = this; const
            c = arguments; z(() => { a.apply(b, c); });
        };
      }; const B = function (a) {
        let b; let c = 0; const e = d.throttleDelay; let g = d.ricTimeout; const h = function () { b = !1, c = f.now(), a(); }; const
          i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout); } : A(() => { k(h); }, !0); return function (a) { let d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)); };
      }; const
        C = function (a) {
          let b; let c; const d = 99; const e = function () { b = null, a(); }; var
            g = function () { const a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e); }; return function () { c = f.now(), b || (b = k(g, d)); };
        }; !(function () {
        let b; const
          c = {
            lazyClass: 'lazyload', loadedClass: 'lazyloaded', loadingClass: 'lazyloading', preloadClass: 'lazypreload', errorClass: 'lazyerror', autosizesClass: 'lazyautosizes', srcAttr: 'data-src', srcsetAttr: 'data-srcset', sizesAttr: 'data-sizes', minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: 0.8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125,
          }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(() => { d.init && F(); });
      }()); const D = (function () {
        let g; let l; let m; let o; let p; let y; let D; let F; let G; let H; let I; let J; const K = /^img$/i; const L = /^iframe$/i; const M = 'onscroll' in a && !/(gle|ing)bot/.test(navigator.userAgent); const N = 0; let O = 0; let P = 0; let Q = -1; const R = function (a) { P--, (!a || P < 0 || !a.target) && (P = 0); }; const S = function (a) { return J == null && (J = x(b.body, 'visibility') == 'hidden'), J || x(a.parentNode, 'visibility') != 'hidden' && x(a, 'visibility') != 'hidden'; }; const T = function (a, c) {
          let d; let f = a; let
            g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, 'opacity') || 1) > 0) && x(f, 'overflow') != 'visible' && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g;
        }; const U = function () {
          let a; let f; let h; let j; let k; let m; let n; let p; let q; let r; let s; let t; const
            u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++) if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]('data-expand')) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break; } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || u[f][i](d.sizesAttr) != 'auto')) && (j = g[0] || u[f]); j && !k && aa(j); }
        }; const V = B(U); const W = function (a) { const b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, 'lazyloaded'); }; const X = A(W); var Y = function (a) { X({ target: a.target }); }; const Z = function (a, b) { try { a.contentWindow.location.replace(b); } catch (c) { a.src = b; } }; const $ = function (a) {
          let b; const
            c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]('data-media') || a[i]('media')]) && a.setAttribute('media', b), c && a.setAttribute('srcset', c);
        }; const _ = A((a, b, c, e, f) => {
          let g; let h; let j; let l; let o; let
            p; (o = v(a, 'lazybeforeunveil', b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute('sizes', e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || '')), p = b.firesLoad || 'src' in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName('source'), $), h ? a.setAttribute('srcset', h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(() => { const b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, 'ls-is-cached'), W(o), a._lazyCache = !0, k(() => { '_lazyCache' in a && delete a._lazyCache; }, 9)), a.loading == 'lazy' && P--; }, !0);
        }); var aa = function (a) {
          if (!a._lazyRace) {
            let b; const c = K.test(a.nodeName); const e = c && (a[i](d.sizesAttr) || a[i]('sizes')); const
              f = e == 'auto'; (!f && l || !c || !a[i]('src') && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, 'lazyunveilread').detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++, _(a, b, f, e, c));
          }
        }; const ba = C(() => { d.loadMode = 3, V(); }); const ca = function () { d.loadMode == 3 && (d.loadMode = 2), ba(); }; var
          da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j('scroll', ca, !0); } }; return {
          _() { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(`${d.lazyClass} ${d.preloadClass}`), j('scroll', V, !0), j('resize', V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]('DOMNodeInserted', V, !0), e[h]('DOMAttrModified', V, !0), setInterval(V, 999)), j('hashchange', V, !0), ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach((a) => { b[h](a, V, !0); }), /d$|^c/.test(b.readyState) ? da() : (j('load', da), b[h]('DOMContentLoaded', V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V(); }, checkElems: V, unveil: aa, _aLSL: ca,
        };
      }());
      var E = (function () {
        let a; const c = A((a, b, c, d) => {
          let e; let f; let
            g; if (a._lazysizesWidth = d, d += 'px', a.setAttribute('sizes', d), n.test(b.nodeName || '')) for (e = b.getElementsByTagName('source'), f = 0, g = e.length; f < g; f++)e[f].setAttribute('sizes', d); c.detail.dataAttr || w(a, c.detail);
        }); const e = function (a, b, d) {
          let e; const
            f = a.parentNode; f && (d = y(a, f, d), e = v(a, 'lazybeforesizes', { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d));
        }; const f = function () {
          let b; const
            c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]);
        }; const
          g = C(f); return { _() { a = b.getElementsByClassName(d.autosizesClass), j('resize', g); }, checkElems: g, updateElem: e };
      }());
      var F = function () { F.i || (F.i = !0, E._(), D._()); }; return c = {
        cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z,
      };
    }
  }));
  /*! ls.rias.min.ks - v4.1.8 */
  !(function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener('lazyunveilread', c, !0); }; b = b.bind(null, a, a.document), typeof module === 'object' && module.exports ? b(require('lazysizes')) : a.lazySizes ? c() : a.addEventListener('lazyunveilread', c, !0); }(window, (a, b, c) => {
    function d(b, c) {
      let d; let e; let f; let g; const
        h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || '')) }, f = function (a, c) { let d = b.getAttribute(`data-${a}`); if (!d) { const e = h.getPropertyValue(`--ls-${a}`); e && (d = e.trim()); } if (d) { if (d == 'true') d = !0; else if (d == 'false') d = !1; else if (l.test(d)) d = parseFloat(d); else if (typeof j[a] === 'function') d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d); } catch (a) { } g[a] = d; } else a in j && typeof j[a] !== 'function' ? g[a] = j[a] : c && typeof j[a] === 'function' && (g[a] = j[a](b, d)); }; for (d in j) f(d); return c.replace(p, (a, b) => { b in g || f(b, !0); }), g;
    } function e(a, b) {
      const c = []; const
        d = function (a, c) { return k[typeof b[c]] ? b[c] : a; }; return c.srcset = [], b.absUrl && (s.setAttribute('href', a), a = s.href), a = ((b.prefix || '') + a + (b.postfix || '')).replace(p, d), b.widths.forEach((d) => {
        const e = b.widthmap[d] || d; const f = b.aspectratio || b.ratio; const g = !b.aspectratio && j.traditionalRatio; const
          h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ''), w: d }; c.push(h), c.srcset.push(h.c = `${h.u} ${d}w`);
      }), c;
    } function f(a, c, d) {
      let f = 0; let g = 0; let
        h = d; if (a) { if (c.ratio === 'container') { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f); } a = e(a, c), a.isPicture = c.isPicture, u && d.nodeName.toUpperCase() == 'IMG' ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(', ')), Object.defineProperty(d, '_lazyrias', { value: a, writable: !0 }); }
    } function g(a, b) { const e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, 'lazyriasmodifyoptions', e), e; } function h(a) { return a.getAttribute(a.getAttribute('data-srcattr') || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute('data-pfsrcset') || ''; } let i; let j; var k = { string: 1, number: 1 }; var l = /^\-*\+*\d+\.*\d*$/; var m = /^picture$/i; var n = /\s*\{\s*width\s*\}\s*/i; var o = /\s*\{\s*height\s*\}\s*/i; var p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi; var q = /^\[.*\]|\{.*\}$/; const r = /^(?:auto|\d+(px)?)$/; var s = b.createElement('a'); const t = b.createElement('img'); var u = 'srcset' in t && !('sizes' in t); const
      v = !!a.HTMLPictureElement && !u; !(function () {
      let b; const d = function () { }; const
        e = {
          prefix: '', postfix: '', srcAttr: 'data-src', absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1,
        }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a; }), i.rias || (i.rias = {}), 'widths' in (j = i.rias) || (j.widths = [], (function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b); }(j.widths))); for (b in e) b in j || (j[b] = e[b]);
    }()), addEventListener('lazybeforesizes', (a) => {
      if (a.detail.instance == c) {
        let b; let d; let e; let k; let l; let m; let o; let p; let q; let s; let t; let u; let
          x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute('sizes')) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName('source'), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, '_lazyrias', { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : q != 'auto' && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))); }
      }
    }, !0); var w = (function () {
      const d = function (a, b) { return a.w - b.w; }; const e = function (a) {
        let b; let c; const d = a.length; let e = a[d - 1]; let
          f = 0; for (f; f < d; f++) if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - 0.13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - 0.6, 1.6), b.cached && (b.d += 0.15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break; } return e;
      }; const f = function (a, b) { let d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ''))).length && (Object.defineProperty(a, '_lazyrias', { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = a.parentNode.nodeName.toUpperCase() == 'PICTURE')), a._lazyrias; }; const g = function (b) {
        const d = a.devicePixelRatio || 1; const
          e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d);
      }; const h = function (b, c) {
        let h; let i; let j; let k; let l; let
          m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName('source'), j = h.length; i < j; i++) if (f(h[i]) && !h[i].getAttribute('type') && (!(k = h[i].getAttribute('media')) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break; } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m;
      }; var
        j = function (d) {
          if (d.detail.instance == c) {
            let e; const
              g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener('lazybeforesizes', j); ('_lazyrias' in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(() => { g.setAttribute(i.srcAttr, e.u), g.setAttribute('src', e.u); }));
          }
        }; return v ? j = function () { } : addEventListener('lazybeforesizes', j), j;
    }());
  }));
}

let onSale = false;
let soldOut = false;
let priceVaries = false;
let images = [];
const firstVariant = {};
// Override Settings
const boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
    enableOTP: true,
    separateRefineByFromFilter: true,
    // filterTreeMobileStyle: 'style2', // 'style2', 'style3'
  },
};

(function () {
  BoostPFS.inject(this);

  /** ************************ CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM ************************* */
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    let firstVariant = data.variants[0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      const paramVariant = data.variants.filter((e) => e.id == Utils.getParam('variant'));
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (let i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          firstVariant = data.variants[i];
          break;
        }
      }
    }
    return data;
  }
  /** ************************ END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM ************************* */
  /** ************************ BUILD PRODUCT LIST ************************* */
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Get Template
    let itemHtml = boostPFSTemplate.productGridItemHtml;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Add Custom class
    const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    const saleClass = onSale ? boostPFSTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add Review
    const itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
    // itemActiveSwapClass
    const itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
    // Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemProducerLabel}}/g, data.barcodes[0]);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    return itemHtml;
  };
  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // For List View
    /** * Prepare data ** */
    const images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    const soldOut = !data.available; // Check a product is out of stock
    const onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    const priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    let firstVariant = data.variants[0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      const paramVariant = data.variants.filter((e) => e.id == Utils.getParam('variant'));
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (let i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          firstVariant = data.variants[i];
          break;
        }
      }
    }
    /** * End Prepare data ** */
    // Get Template
    let itemHtml = boostPFSTemplate.productListItemHtml;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Add Custom class
    const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    const saleClass = onSale ? boostPFSTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Review
    const itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
    // Add Price
    const itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    // Description
    let itemDescription = jQ(`<p>${data.body_html}</p>`).text();
    itemDescription = (itemDescription.split(' ')).length > 35 ? `${itemDescription.split(' ').splice(0, 35).join(' ')}...` : itemDescription.split(' ').splice(0, 35).join(' ');
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
    // itemActiveSwapClass
    const itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
    // Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemProducerLabel}}/g, data.barcodes[0]);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    return itemHtml;
    // End For List View
  };
  /** ************************ END BUILD PRODUCT LIST ************************* */
  /** ************************ BUILD PRODUCT ITEM ELEMENTS ************************* */
  function buildGridWidthClass() {
    let gridWidthClass = '';
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = 'boost-pfs-filter-grid-width-2';
        break;
      case 3:
        gridWidthClass = 'boost-pfs-filter-grid-width-3';
        break;
      case 5:
        gridWidthClass = 'boost-pfs-filter-grid-width-5';
        break;
      default:
        gridWidthClass = 'boost-pfs-filter-grid-width-4';
        break;
    }
    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
        break;
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
        break;
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
        break;
    }
    return gridWidthClass;
  }

  function buildImages(data) {
	  let html = '';
	  // Build Main Image
	  const thumbUrl = Utils.getFeaturedImage(images, '260x');
	  html += `${'<img class="abc boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"'
		  + 'data-srcset="'}${Utils.getFeaturedImage(images, '180x')} ` + '180w' + `, ${Utils.getFeaturedImage(images, '260x')} ` + '260w' + `, ${Utils.getFeaturedImage(images, '800x')} ` + '360w' + '" '
		  + `data-src="${thumbUrl}" `
		  + 'data-widths="[180, 260, 360]" '
		  + 'data-sizes="auto" '
		  + 'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" '
		  + 'alt="{{itemTitle}}" />';
	  // Build Image Swap
	  if (boostPFSThemeConfig.custom.active_image_swap) {
		  const flipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1].src, '260x') : thumbUrl;
		  const flipImageSrcset = images.length > 1 ? `${Utils.optimizeImage(images[1].src, '180x')} ` + '180w' + `, ${Utils.optimizeImage(images[1].src, '260x')} ` + '260w' + `, ${Utils.optimizeImage(images[1].src, '800x')} ` + '360w' : `${Utils.getFeaturedImage(images, '180x')} ` + '180w' + `, ${Utils.getFeaturedImage(images, '260x')} ` + '260w' + `, ${Utils.getFeaturedImage(images, '800x')} ` + '360w';
		  html += `${'<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"'
		  + 'data-srcset="'}${flipImageSrcset}" `
		  + `data-src="${flipImageUrl}" `
		  + 'data-widths="[180, 260, 360]" '
		  + 'data-sizes="auto" '
		  + `src="${flipImageUrl}" `
		  + 'alt="{{itemTitle}}" />';
	  }
	  return html;
  }

  function buildVendor(data) {
    let html = '';
    if (boostPFSThemeConfig.custom.show_vendor) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    let html = '';
    if (boostPFSThemeConfig.custom.show_price) {
      html = '<p class="boost-pfs-filter-product-item-price">';
      if (onSale) {
        html += `<span class="boost-pfs-filter-product-item-sale-price">${Utils.formatMoney(data.price_min)}</span>`;
        html += `<s>${Utils.formatMoney(data.compare_at_price_min)}</s> `;
      } else {
        if (priceVaries) {
          html += `<span class="boost-pfs-filter-product-item-price-from-text">${boostPFSThemeConfig.label_basic.from} ` + '</span>';
        }
        html += `<span class="boost-pfs-filter-product-item-regular-price">${Utils.formatMoney(data.price_min)}</span>`;
      }
      html += '</p>';
    }
    return html;
  }

  function buildLabels(data) {
    // Build Sold out label
    let soldOutLabel = '';
    if (boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
    }
    // Build Sale label
    let saleLabel = '';
    if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
    }
    // Build Labels
    return soldOutLabel + saleLabel;
  }
  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels(data, showall) {
    if (showall) {
      var tagLabel = '';
      if (data.tags) {
        for (var i = 0; i < data.tags.length; i++) {
          var tag = data.tags[i];
          if (tag.indexOf('pfs:label') !== -1) {
            var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
            tagLabel += preTagLabel;
          }
        }
      }
    } else {
      var tagLabel = '';
      if (data.tags) {
        for (var i = data.tags.length - 1; i >= 0; i--) {
          tag = data.tags[i];
          if (tag.indexOf('pfs:label') !== -1) {
            var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
            tagLabel += preTagLabel;
            break;
          }
        }
      }
    }
    return tagLabel;
  }

  // Build Color Swatches
  function buildColorSwatches(data) {
    let colorSwatchesHtml = '';
    if (boostPFSThemeConfig.custom.display_item_swatch) {
      colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';
      for (let index = 0; index < data.options.length; index++) {
        const option = data.options[index].toLowerCase();
        if (option == 'color') {
          let colorlist = '';
          let color = '';
          let totalVariants = 0;
          for (let k = 0; k < data.variants.length; k++) {
            const variant = data.variants[k];
            color = variant.options[index];
            if (colorlist.indexOf(color) == -1) {
              if (totalVariants < 4) {
                const text = Utils.slugify(color);
                const border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
                let backgroundImage = Utils.optimizeImage(variant.image, '24x');
                let dataImg = '';
                let dataColor = '#fff';
                dataColors = variant.option_color.toLowerCase().split(' ');
                const i = dataColors.length - 1;
                if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
                  dataColor = dataColors[i];
                }

                if (variant.image !== null) {
                  dataImg = `data-img='${Utils.optimizeImage(variant.image)}'`;
                } else {
                  const _file = variant.option_color.toLowerCase().replace(/ /g, '-');
                  backgroundImage = `${boostPFSAppConfig.general.file_url.split('?')[0]}color-${_file}.png`;
                }

                colorSwatchesHtml += '<li>';
                colorSwatchesHtml += `<div class="tooltip">${color}</div>`;
                colorSwatchesHtml += `<label style="${border} background-color: ${dataColor}; background-image: url(${backgroundImage});" ${dataImg}></label>`;

                // colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
                colorSwatchesHtml += '</li>';
              }
              const templist = `${colorlist + color} `;
              colorlist = templist;

              totalVariants++;
            }
          }
          // if (totalVariants == 1) {
          // colorSwatchesHtml = '<ul class="boost-pfs-filter-item-swatch">';
          // }
          if (totalVariants > 4) {
            colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
            colorSwatchesHtml += `<a href="{{itemUrl}}" title="More Color">+${totalVariants - 4}</a>`;
            colorSwatchesHtml += '</li>';
            totalVariants = 0;
          }
        }
      }
      colorSwatchesHtml += '</ul>';
    }
    return colorSwatchesHtml;
  }

  // Build Color Swatches
  function eventColorSwatches() {
    jQ('.boost-pfs-filter-item-swatch li label').each(function () {
      const img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
      jQ(this).hover(function () {
        const newImage = jQ(this).data('img');
        img.attr('srcset', newImage);
      });
    });
  }

  /** ************************ END BUILD PRODUCT ITEM ELEMENTS ************************* */
  /** ************************ BUILD TOOLBAR ************************* */
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    const currentPage = parseInt(Globals.queryParams.page);
    const totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }
    if (Settings.getSettingValue('general.paginationType') == 'default') {
      let paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      let previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      let nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      const beforeCurrentPageArr = [];
      for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      const afterCurrentPageArr = [];
      for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      let pageItemsHtml = '';
      const pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (let iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    let html = '';
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      const sortingArr = Utils.getSortingList();
      if (sortingArr) {
        const paramSort = Globals.queryParams.sort || '';
        // Build content
        let sortingItemsHtml = '';
        for (const k in sortingArr) {
          activeClass = '';
          if (paramSort == k) {
            activeClass = 'boost-pfs-filter-sort-item-active';
          }
          sortingItemsHtml += `<li><a href="#" data-sort="${k}" class="${activeClass}">${sortingArr[k]}</a></li>`;
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    let labelSort = '';
    const paramSort = Globals.queryParams.sort || '';
    if (paramSort.length > 0) {
      const labelHandle = `sorting_${paramSort.replace(/\-/g, '_')}`;
      labelSort = Labels[labelHandle];
    } else {
      labelSort = Labels.sorting_heading;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    const _this = this;
    jQ('.boost-pfs-filter-filter-dropdown a').click(function (e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).data('sort'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });

    jQ('.boost-pfs-filter-custom-sorting > button').click(() => {
      if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
        jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
        // jQ('.boost-pfs-filter-tree-v').hide();
      }
    });

    jQ(Selector.filterTreeMobileButton).click(() => {
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
    });
  };
  // For Toolbar - Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    let itemHtml = `<span>${boostPFSThemeConfig.label.toolbar_viewas}</span>`;
    itemHtml += `<a href="${Utils.buildToolbarLink('display', 'list', 'grid')}" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>`;
    itemHtml += `<a href="${Utils.buildToolbarLink('display', 'grid', 'list')}" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>`;
    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

    return itemHtml;
  };

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function () {
    let html = '';
    if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
      const numberList = Settings.getSettingValue('general.showLimitList');
      if (numberList != '') {
        // Build content
        let showLimitItemsHtml = '';
        const arr = numberList.split(',');
        for (const k in sortingArr) {
          showLimitItemsHtml += `<option value="${arr[k].trim()}">${arr[k].trim()}</option>`;
        }
        html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      }
    }
    return html;
  };
  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function (colData) {
    if (!colData) colData = this.collectionData;
    let breadcrumbItemsHtml = '';
    if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
      if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        const colInfo = colData.collection;
        if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, `/collections/${colInfo.handle}`).replace(/{{itemTitle}}/g, colInfo.title);
          breadcrumbItemsHtml += ' {{breadcrumbDivider}} ';
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
        } else {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
        }
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
      }
    }
    return breadcrumbItemsHtml;
  };
  /** ************************ END BUILD TOOLBAR ************************* */
  function matchHeightImage() {
    // jQ('.boost-pfs-filter-product-item-main-image').load(function() {
    // 	var imageContainer = jQ(this).parent();
    // 	imageContainer.css('width', '100%').css('height', jQ(this).height());
    // }).each(function() {
    // 	if (this.complete) jQ(this).load();
    // });
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    eventColorSwatches();

    if (!data) data = this.data;

    // Intergrate Review Shopify
    if (window.SPR) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    let totalProduct = `${data.total_product}<span> ${boostPFSThemeConfig.label.items_with_count_other}</span>`;
    if (data.total_product == 1) {
      totalProduct = `${data.total_product}<span> ${boostPFSThemeConfig.label.items_with_count_one}</span>`;
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);
    matchHeightImage();
    jQ(window).resize(() => {
      matchHeightImage();
    });

    jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

    // Prevent double tap on iOS
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
      Utils.isMobile() && jQ('.boost-pfs-filter-product-item').find('a').on('touchstart', () => { isScrolling = !1; }).on('touchmove', () => { isScrolling = !0; })
        .on('touchend', function () { isScrolling || (window.location = jQ(this).attr('href')); });
    }

    // Fix image not loaded on mobile
    // (Utils.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));
  };

  ProductListPlaceholder.prototype.render = function () {
    // Set limit number for product skeleton
    const placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
    // Build placeholder items
    const placeholderItem = this.compileTemplate();
    this.$element = [];
    for (let i = 0; i < placeholderLimit; i++) {
		  this.$element.push(jQ(placeholderItem));
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
		  this.setShow();
    } else {
		  this.setHide();
    }
  };

  ProductListPlaceholder.prototype.compileTemplateExtra = function () {
    const { display } = Globals.queryParams;
    switch (display) {
      case 'list':
        // Todo: Build placeholder for List mode
        var template = boostPFSTemplate.productListPlaceholderHtml;
        var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
        var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
        /**
			 * Set product class for product skeleton (to set column, style, etc.)
			 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
			 */
        break;
    }
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100);
  };

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function (a, b) {};
}());
